export const SERVICES = [
  {
    slug: 'ux-design',
    name: 'UX Design',
    heading: 'UX design for digital products and websites',
    blurb:
      'User experience design for startups and small businesses, from discovery and research through to prototyping and testing.',
  },
  {
    slug: 'ui-design',
    name: 'UI Design',
    heading: 'UI design that balances usability and aesthetics',
    blurb:
      'Interface design, design systems and product UI that feel considered, consistent and easy to work with for product teams.',
  },
  {
    slug: 'web-design',
    name: 'Web Design',
    heading: 'Web design and build for growing teams',
    blurb:
      'Designing and building fast, modern marketing sites, landing pages and product sites that are easy to maintain and iterate.',
  },
];

export const CITIES = [
  { slug: 'glasgow', name: 'Glasgow' },
  { slug: 'edinburgh', name: 'Edinburgh' },
  { slug: 'dundee', name: 'Dundee' },
  { slug: 'manchester', name: 'Manchester' },
  { slug: 'birmingham', name: 'Birmingham' },
  { slug: 'leicester', name: 'Leicester' },
  { slug: 'london', name: 'London' },
  { slug: 'liverpool', name: 'Liverpool' },
  { slug: 'leeds', name: 'Leeds' },
];

export const findServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
export const findCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
